.questionTagInputs {
    display: flex;
    column-gap: 2ch;
    justify-content: space-between;
    flex-wrap: wrap;
}

.questionTagInputs > div {
    flex: 1;
    min-width: 40ch;
}